import React from "react";

const countries = [
  "United States of America", "Afghanistan", "Åland Islands", "Albania", 
  "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", 
  "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", 
  "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain"
];

const paymentMethods = [
  { key: "paypal", label: "PayPal Commerce" },
  { key: "check", label: "Check / Money Order" },
  { key: "credit", label: "Credit Card" },
];

export default function PaymentRestriction() {
  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      <div className="max-w-6xl mx-auto bg-white shadow rounded-lg p-6">
        <h1 className="text-2xl font-semibold mb-2">Payment restrictions</h1>
        <p className="text-sm text-gray-600 mb-4">
          Learn more about{" "}
          <a href="#" className="text-blue-600 underline">
            payment method restrictions
          </a>
        </p>
        <p className="text-sm text-gray-600 mb-6">
          Please mark the checkbox(es) for the country or countries in which you
          want the payment method(s) not available.
        </p>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  Country
                </th>
                {paymentMethods.map((method) => (
                  <th
                    key={method.key}
                    className="text-left px-4 py-2 border-b border-gray-200"
                  >
                    {method.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {countries.map((country, idx) => (
                <tr
                  key={country}
                  className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  <td className="px-4 py-2 border-b border-gray-200">
                    {country}
                  </td>
                  {paymentMethods.map((method) => (
                    <td
                      key={method.key}
                      className="px-4 py-2 border-b border-gray-200 text-center"
                    >
                      <input
                        type="checkbox"
                        className="form-checkbox h-5 w-5 text-blue-600"
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-end mt-6">
          <button className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition">
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
